var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "theme-select",
      class: {
        "theme-input__field-holder--error": !!_vm.errors.has(_vm.newName),
        "theme-input__field-holder--is-disabled": _vm.disabled,
        "theme-input__field-holder--is-dirty": _vm.isDirty
      },
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _vm.showLabel && _vm.labelHtml
        ? _c("label", {
            staticClass: "theme-input__label",
            domProps: { innerHTML: _vm._s(_vm.labelHtml) }
          })
        : _vm.showLabel && _vm.label
        ? _c("label", { staticClass: "theme-input__label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
            _vm.isRequired
              ? _c("span", { staticClass: "theme-input__label-asterisk" }, [
                  _vm._v("*")
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "theme-select__wrapper" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model,
                expression: "model"
              }
            ],
            class: [
              "theme-input theme-input--select",
              {
                "theme-input--select-extra": _vm.isExtraInfo
              }
            ],
            style: { color: _vm.model ? "black" : "grey" },
            attrs: { type: "text", name: _vm.name, disabled: _vm.disabled },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.model = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function($event) {
                  _vm.$emit("input", _vm.model)
                  _vm.$emit("change", _vm.model)
                }
              ]
            }
          },
          [
            _vm.placeholder
              ? _c("option", { attrs: { disabled: "", value: "" } }, [
                  _vm._v(_vm._s(_vm.placeholder))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.zeroOption && _vm.showZeroOption == 1
              ? _c("option", { key: "zero-option", attrs: { value: "0" } }, [
                  _vm._v("\n        " + _vm._s(_vm.zeroOption) + "\n      ")
                ])
              : _vm.showZeroOption == 1
              ? _c("option", { key: "zero-option", domProps: { value: "" } })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.options, function(option, key) {
              return _c(
                "option",
                { key: key + "-option", domProps: { value: key } },
                [_vm._v("\n        " + _vm._s(option) + "\n      ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm.isExtraInfo
          ? _c(
              "div",
              { staticClass: "theme-input__extra-info" },
              [_vm._t("extra-info")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.errors.has(_vm.newName)
          ? _c("span", {
              staticClass:
                "icon-warning theme-input__icon theme-input__icon-error right-9"
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.errors.has(_vm.newName) && _vm.showErrorMessage
        ? _c("div", { staticClass: "theme-input__error-text" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d26286ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d26286ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeSelect.vue
// module id = 607
// module chunks = 1